// extracted by mini-css-extract-plugin
export default {"container":"move_container__rSqMo","label":"move_label__IPUhw","picker":"move_picker__tKkvP","loading-value":"move_loading-value__HQvkk"};